module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f000v-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/003"
    }
  }, [_vm._v("1. "), _c('em', [_vm._v("Implosion!")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/004"
    }
  }, [_vm._v("2. "), _c('em', [_vm._v("Autopsy Report")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('em', [_vm._v("Ghost Hunters")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. "), _c('em', [_vm._v("New Meat")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. "), _c('em', [_vm._v("Cold Spot")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. "), _c('em', [_vm._v("What Are You in For?")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. "), _c('em', [_vm._v("Killer Ghost")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. "), _c('em', [_vm._v("You Know I Did It")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. "), _c('em', [_vm._v("The Séance")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. "), _c('em', [_vm._v("Think He Saw Us?")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. "), _c('em', [_vm._v("Inside the Bag")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. "), _c('em', [_vm._v("Fire?")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. "), _c('em', [_vm._v("Call 911")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. "), _c('em', [_vm._v("Let Me Out")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. "), _c('em', [_vm._v("Somebody Murdered Me")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. "), _c('em', [_vm._v("The Mist")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. "), _c('em', [_vm._v("Liar!")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. "), _c('em', [_vm._v("Fight or Flight")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. "), _c('em', [_vm._v("Exploding Head")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-362cdfb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/002.vue
// module id = 60
// module chunks = 0